

class AccordionItemHTMLElement extends HTMLElement {
    static observedAttributes = ['open'];

    constructor() {
        super();
        this.boundToggle = this.toggle.bind( this );
    }

    connectedCallback() {
        this.toggler?.addEventListener( 'click', this.boundToggle );
    }

    adoptedCallback() {}

    disconnectedCallback() {
        this.toggler?.removeEventListener( 'click', this.boundToggle );
    }

    get group() {
        return this.closest( 'accordion-group' );
    }

    get toggler() {
        return this.querySelector( 'button' );
    }

    get content() {
        return this.querySelector( '[aria-hidden]' );
    }

    get siblings() {
        return this.group?.querySelectorAll( 'accordion-item' );
    }

    toggle() {
        this.siblings?.forEach( sibling => {
            if ( sibling !== this ) sibling.removeAttribute( 'open' );
        } );
        this.toggleAttribute( 'open' );
    }

    /**
     * @param {string} name
     * @param {string} oldVal
     * @param {string} newVal
     */
    attributeChangedCallback( name, oldVal, newVal ) {
        switch ( name ) {
            case 'open':
                if ( oldVal === null ) {
                    this.content?.setAttribute( 'aria-hidden', 'false' );
                } else {
                    this.content?.setAttribute( 'aria-hidden', 'true' );
                }
                break;
        }
    }
}

customElements.define( 'accordion-item', AccordionItemHTMLElement );